module.exports = __webpack_public_path__ + "img/reg-2.09ea9e96.jpg";